<template>
    <vs-popup class="create-return-stock-popup" id="popup" title="CREATE RETURN INVENTORY" @close="open = false"
        :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow> 
            <vs-alert color="danger" class="h-auto">
                Note: Please select the quantity for items you wish to return. If no quantity is selected (0), the item will not be included in the return process. Adjust the selected return quantity to return only the desired items.
            </vs-alert>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(onClickCreateReturnStock)" autocomplete="off">
                    <vs-table :hoverFlat="true" class="mt-8" :data="item_stock">

                        <template slot="thead">
                            <vs-th>WORK ORDER</vs-th>
                            <vs-th>WORK ORDER STATUS</vs-th>
                            <vs-th>WORK ORDER QC STATUS</vs-th>
                            <vs-th>MANUFACTURE DATE</vs-th>
                            <vs-th>EXPIRATION DATE</vs-th>
                            <vs-th>COMPLETED QTY (KG)</vs-th>
                            <vs-th>PENDING TO RETURN (KG)</vs-th>
                            <vs-th>SELECTED RETURN QUANTITY (KG)</vs-th>
                            <!-- <vs-th>QUANTITY REASSIGN TO CUSTOMER?</vs-th> -->
                            <vs-th>QUANTITY SEND TO DISPATCH?</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr v-if="tr_item.remaining_to_be_return_quantity > 0" :data="tr_item" :key="index_item"
                                v-for="(tr_item, index_item) in data">

                                <vs-td class="text-primary font-semibold cursor-pointer" :data="tr_item.work_order_code">
                                    {{ tr_item.work_order_code }}
                                </vs-td>

                                <vs-td class="text-sm" :data="tr_item.work_order_status.name">
                                    {{ tr_item.work_order_status.name }}
                                </vs-td>

                                <vs-td class="text-sm" :data="tr_item.work_order_qc_status">
                                    {{ tr_item.work_order_qc_status || 'N/A' }}
                                </vs-td>

                                <vs-td class="text-sm" :data="tr_item.manufacture_date">
                                    {{ tr_item.manufacture_date }}
                                </vs-td>

                                <vs-td class="text-sm" :data="tr_item.expiration_date">
                                    {{ tr_item.expiration_date }}
                                </vs-td>
                                
                                <vs-td :data="tr_item.completed_quantity">
                                    {{ Number(tr_item.completed_quantity).toFixed(3) }}
                                </vs-td>

                                <vs-td class="text-sm" :data="tr_item.remaining_to_be_return_quantity">
                                    {{ tr_item.remaining_to_be_return_quantity }}
                                </vs-td>

                                <vs-td class="text-sm" :data="tr_item.selected_quantity">
                                    <ValidationProvider :vid="index_item + 'selected_quantity'"
                                        :name="index_item + 'selected_quantity'"
                                        :rules="`min_qty:${tr_item.remaining_to_be_return_quantity}`" v-slot="{ errors }">
                                        <vs-input type="text" v-model="tr_item.selected_quantity" class="w-full"
                                            :name="index_item + 'selected_quantity'" :danger="!!errors[0]"
                                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                                    </ValidationProvider>
                                </vs-td>

                                <!-- <vs-td :data="data[index_item].is_quantity_reassigned">
                                    <vs-dropdown>

                                        <a class="flex items-center">
                                            {{ tr_item.is_quantity_reassigned || 'SELECT' }}
                                            <i class="material-icons"> expand_more </i>
                                        </a>

                                        <vs-dropdown-menu style="z-index: 99999">

                                            <vs-dropdown-item @click="onClickOption(option, tr_item.id)"
                                                v-for="(option, index) in ['Yes', 'No']" :key="index">
                                                <span>{{ option }} </span>
                                            </vs-dropdown-item>

                                        </vs-dropdown-menu>
                                    </vs-dropdown>
                                </vs-td> -->

                                <vs-td :data="data[index_item].is_quantity_sent_to_dispatch">
                                    <vs-dropdown>

                                        <a class="flex items-center">
                                            {{ tr_item.is_quantity_sent_to_dispatch }}
                                            <i class="material-icons"> expand_more </i>
                                        </a>

                                        <vs-dropdown-menu style="z-index: 99999">

                                            <vs-dropdown-item @click="onClickDispatchOption(option, tr_item.id)"
                                                v-for="(option, index) in ['Yes', 'No']" :key="index">
                                                <span>{{ option }} </span>
                                            </vs-dropdown-item>

                                        </vs-dropdown-menu>
                                    </vs-dropdown>
                                </vs-td>

                            </vs-tr>
                        </template>

                    </vs-table>
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
    </vs-popup>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        item_stock: [{ is_quantity_reassigned: false }]
    }
}
export default {
    name: "CreateReturnInventoryPopUp",
    data() {
        return initialState()
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
        async openPopup(return_stock = [], item_stock = []) {
            this.item_stock = item_stock
            this.item_stock = this.item_stock.filter((x) => ['Part Returned', 'Returned', 'Dispatched', 'Customer-Received'].includes(x.status))
            await this.calculateReturnStockItemQuantity(return_stock)
            this.open = true
        },
        async calculateReturnStockItemQuantity(return_stock) {
            this.item_stock.forEach((x) => {
                let related_return_items = return_stock.filter((y) => x.id === y.formulation_stock_inventory_id)
                let related_return_items_total = related_return_items.reduce((a, b) => a + Number(b.quantity), 0)
                x.remaining_to_be_return_quantity = Number(x.completed_quantity) - Number(related_return_items_total)
                x.selected_quantity = 0
                x.is_quantity_reassigned = 'YES'
                x.is_quantity_sent_to_dispatch = 'No'
                return x
            })
        },
        async onClickCreateReturnStock() {
            try {
                let selected_item_stock = this.item_stock.filter((x) => Number(x.selected_quantity) > 0 )
                if(selected_item_stock.length === 0) {
                    this.showErrorMessage('Please select at least one item to return!')
                    return
                }
                let payload = {
                    items: selected_item_stock
                        .map((x) => ({
                            formulation_stock_inventory_id: x.id,
                            quantity: Number(x.selected_quantity).toFixed(4),
                            is_quantity_reassigned: true,
                            is_quantity_sent_to_dispatch: x.is_quantity_sent_to_dispatch === 'Yes' ? true : false
                        })).filter((x) => Number(x.quantity) !== 0)
                }
                payload.items = payload.items.filter((x) => {
                    x.is_quantity_sent_to_dispatch = x.is_quantity_reassigned ? x.is_quantity_sent_to_dispatch : false
                    return x
                })
                await InventoryRepository.createReturnProductStock(payload)
                this.showSuccessMessage('Return inventory created successfully!')
                this.open = false
                this.$emit('refreshItems')
            } catch (error) {
                this.convertAndNotifyError(e)
            }
        },
        onClickOption(option, stock_id) {
            this.item_stock = this.item_stock.map((x) => {
                if (x.id === stock_id) {
                    x.is_quantity_reassigned = option
                }
                return x
            })
        },
        onClickDispatchOption(option, stock_id) {
            this.item_stock = this.item_stock.map((x) => {
                if (x.id === stock_id) {
                    x.is_quantity_sent_to_dispatch = option
                }
                return x
            })
        }
    },
}
</script>
<style scoped>
.create-return-stock-popup>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
}

.style-chooser .vs__dropdown-menu {
    z-index: 10030 !important;
}
</style>